import { render, staticRenderFns } from "./SpecSettingsPopupWrappable.vue?vue&type=template&id=f2dc2380&scoped=true&lang=pug&"
import script from "./SpecSettingsPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./SpecSettingsPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./SpecSettingsPopupWrappable.vue?vue&type=style&index=0&id=f2dc2380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dc2380",
  null
  
)

export default component.exports